/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.programs.modals.cannotRelink.controllers', [])

.controller('ProgramsModalsCannotRelinkController', ['$scope', '$uibModalInstance', function($scope,$uibModalInstance) {

    $scope.programsModalsCannotRelink = {

      model: "This event’s schedule details can’t be  re-linked to the template because the schedule which created this event was edited and this event was suspended.",

      init: function() {},

      cancel: function() {
        $uibModalInstance.dismiss('cancel');
      },

      done: function() {
        $uibModalInstance.close(this.model);
      }

    };

    $scope.programsModalsCannotRelink.init();

}]);
